export default __webpack_public_path__ + "static/media/480_dummy2016-sportbekleidung01-de.94371ab8.png";